import { render } from "./registrations.vue?vue&type=template&id=3b55bcd6&scoped=true"
import script from "./registrations.vue?vue&type=script&lang=js"
export * from "./registrations.vue?vue&type=script&lang=js"

import "./registrations.vue?vue&type=style&index=0&id=3b55bcd6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b55bcd6"

export default script